/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Chars_LabelInputs */

const en_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Characters Per Line`)
};

const fr_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de caractères par ligne`)
};

const de_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Zeile`)
};

const it_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri per riga`)
};

const ru_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке`)
};

const es_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres por línea`)
};

const zh_cn2_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最大字符数`)
};

const ja_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行あたりの最大文字数`)
};

const hi_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति अधिकतम अक्षर`)
};

const pt_pt2_edit_event_group_max_chars_label = /** @type {(inputs: Edit_Event_Group_Max_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Max Characters Per Line" |
*
* @param {Edit_Event_Group_Max_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_chars_label = /** @type {((inputs?: Edit_Event_Group_Max_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_max_chars_label(inputs)
	if (locale === "de") return de_edit_event_group_max_chars_label(inputs)
	if (locale === "it") return it_edit_event_group_max_chars_label(inputs)
	if (locale === "ru") return ru_edit_event_group_max_chars_label(inputs)
	if (locale === "es") return es_edit_event_group_max_chars_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_max_chars_label(inputs)
	if (locale === "ja") return ja_edit_event_group_max_chars_label(inputs)
	if (locale === "hi") return hi_edit_event_group_max_chars_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_max_chars_label(inputs)
	return en_edit_event_group_max_chars_label(inputs)
});